<template lang="pug">
	
	.story-text
		slot(name="text-content")

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'


  	@Component({
		name: 'StoryText',
		components: { }
	})

	class StoryText extends Vue {

		// mounted () {
		// 	super.mounted()

		// 	this._dom()
		// }

		// init () {
		// 	super.init()

		// }

		// _bind () {
		// 	super._bind()
		// }

		// _dom () {
		
		// }

		// _intervals () {
			
		// }

		// _points () {

		// } 

		// _resize () {
		// 	super._resize()

		// 	this._intervals()
		// 	this._points()
		// }

		// _on () {
		// 	super._on()
		// }

		// _off () {
		// 	super._off()
			
		// }

	}

	export default StoryText

</script>


<style lang="stylus">
	
	@import '../../theme/utils'
	@import '../../theme/variables'
	
	.story-text
		width 100%

		.text
			color #fff
			font-size em(18px)
			line-height em(27px,18px)
			font-family $FONT_THIRDLY
			
			span.underlined
				text-decoration underline
				font-family $FONT_PRIMALY

			span.bold
				font-size 18px
				font-family $FONT_PRIMARY				

	

</style>


// WEBPACK FOOTER //
// story-text.vue?55b6e074